import type { FC } from 'react'

import { StyledText } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import { getWhiteLabelForDealerStyle } from '@skytech/utils'
import CloudDownloadOutlineIcon from 'mdi-react/CloudDownloadOutlineIcon'

import { useAppContext } from '@/App.context'
import { FormattedNumber } from '@/components/FormattedNumber'
import { useTranslation } from '@/components/i18n/hooks'
import { Translation } from '@/components/i18n/Translation'
import { exportDataToExcel } from '@/util/exportDataToExcel'

type ExportParams = Parameters<typeof exportDataToExcel>
const TARGET_EXCEL_MAX_SIZE = 1000000

// todo: move to common UI lib
export const ExportToExcel: FC<{
  data: ExportParams[0]
  filename: ExportParams[1]
  options?: ExportParams[2]
}> = ({ data, filename, options }) => {
  const translate = useTranslation()
  const { whiteLabel } = useAppContext()
  const exportData: ExportParams[0] =
    data.length > TARGET_EXCEL_MAX_SIZE ? data.slice(0, TARGET_EXCEL_MAX_SIZE) : data

  return (
    <Button
      className="mx-0 px-0"
      variant="tertiary"
      Icon={<CloudDownloadOutlineIcon />}
      onClick={() => exportDataToExcel(exportData, filename, { ...options, translate })}
      whiteLabel={getWhiteLabelForDealerStyle(whiteLabel)}
    >
      <Translation
        id="Export {count} {count, plural, one {result} other {results}} to excel"
        count={
          // todo: Remove important when StyledText is refactored
          <StyledText className="!font-bold" whiteLabel={getWhiteLabelForDealerStyle(whiteLabel)}>
            <FormattedNumber amount={exportData.length} />
          </StyledText>
        }
      />
    </Button>
  )
}
